import React, { useEffect, useState } from 'react';
import {
    Box, Container, createStyles, Dialog, FormControl, FormControlLabel, Grid, InputLabel, makeStyles, MenuItem, Radio,
    RadioGroup, Select, Tab, TextField, Theme, IconButton, FormHelperText
} from "@material-ui/core";
import Button from "@material-ui/core/Button";
import DialogContent from "@material-ui/core/DialogContent";
import DialogTitle from "@material-ui/core/DialogTitle";
import DialogContentText from "@material-ui/core/DialogContentText";
import { Autocomplete, TabContext, TabList, TabPanel } from '@material-ui/lab';
import useCommonApi from '../../api/useCommonApi';
import { ICliente } from "../../entities/catalogos/ICliente";
import CloseIcon from '@material-ui/icons/Close';
import { IFacturadorDto } from '../../entities/catalogos/IClienteDto';
import LoadingDialog from '../controls/LoadingDialog';
import swal from 'sweetalert2'
import ReferenciaNumberField from '../controls/ReferenciaNumberField';
import { useSnackbar } from 'notistack';
import Help, { IHelp } from '../help/Help';
import { enums } from "../../enums/enums";
import { validarCurp, validarRfc } from "../../blocks/utility";
import { traducirButton, traducirLabel, traducirMessage } from  '../../blocks/traductor';



interface Props {
    abierto: boolean
    confirmar: () => void
    cerrar: () => void
    maxWidth?: 'lg' | 'md' | 'sm' | 'xl'
    setFacturador: (facturador: any) => void
    ayuda: IHelp,
    clienteId: number
    usuario: string

    empresaId: number
}

export interface IAutocomplete {
    id: number | string
    nombre: string
    nombreColonia: string
    descripcion?: string
    ciudad: any
    pais: any
    estado: any
    codigoPostal: any
}


const useStyles = makeStyles((theme: Theme) =>
    createStyles({
        root: {
            flexGrow: 1,
        },
        menuButton: {
            marginRight: theme.spacing(2),
        },
        principal: {
            backgroundColor: "#fff",
            margin: "0px",
            padding: "10px",
        },
        container: {
            backgroundColor: "#e5e5e5",
        },
        text: {
            backgroundColor: "#fff",
        },
        div_rfc: {
            width: '100%',
        },
        label: {
            fontSize: '18px',
        },

        icon: {
            width: "40px",
            height: "40px",
            minWidth: "40px",
            borderRadius: "20px",
            backgroundColor: "#19754e",
            color: "#fff",
            textAlign: "center",
            paddingTop: "5px"
        },
        actions: {
            textAlign: "center",
            width: "100%",
            display: "block",
            padding: "30px 0px",
        },
        button: {

            backgroundColor: "#00653b",
            color: "#fff"
        },
        table: {
            minWidth: 650,
        },
        padding: {
            padding: "10px 0px"
        }
    }),
);


const AgregarFacturador = ({ abierto, cerrar, confirmar, maxWidth, setFacturador, ayuda, clienteId, usuario, empresaId }: Props) => {

    const classes = useStyles();
    const apiSource = useCommonApi();
    const [tabFacturador, setTabFacturador] = useState("DatosGenerales");
    const [tipoTelefono, setTipoTelefono] = useState(1);
    const [tiposPersona, setTiposPersona] = useState<any[]>([]);
    const [residenciasFiscales, setResidenciasFiscales] = useState<any[]>([]);
    const [regimenesFiscales, setRegimenesFiscales] = useState<any[]>([]);
    const [usosCfdi, setUsosCfdi] = useState<any[]>([]);
    const [giros, setGiros] = useState<any[]>([]);
    const [metodosPago, setMetodosPago] = useState<any[]>([]);
    const [paises, setPaises] = useState<any[]>([]);
    const [estados, setEstados] = useState<any[]>([]);
    const [ciudades, setCiudades] = useState<any[]>([]);
    const [colonias, setColonias] = useState<any[]>([]);
    const [regimenFiscalObligatorio, setRegimenFiscalObligatorio] = useState(false);
    const [usoCfdiObligatorio, setUsoCfdiObligatorio] = useState(false);

    const [tipoPersona, setTipoPersona] = useState(0);
    const [residenciaFiscal, setResidenciaFiscal] = useState("0");
    const [regimenFiscal, setRegimenFiscal] = useState(0);
    const [usoCfdi, setUsoCfdi] = useState(0);
    const [razonSocial, setRazonSocial] = useState('');
    const [nombreComercial, setNombreComercial] = useState('');
    const [rfc, setRFC] = useState('');
    const [curp, setCURP] = useState('');
    const [tipoGiro, setTipoGiro] = useState(0);
    const [metodoPagoId, setMetodoPagoId] = useState(0);
    const [paisId, setPaisId] = useState(0);
    const [estadoId, setEstadoId] = useState(0);
    const [ciudadId, setCiudadId] = useState(0);
    const [colonia, setColonia] = useState<string[] | any>([]);
    const [coloniaId, setColoniaId] = useState(0);
    const [calle, setCalle] = useState('');
    const [codigoPostal, setCodigoPostal] = useState('');
    const [noExterior, setNoExterior] = useState('');
    const [noInterior, setNoInterior] = useState('');
    const [telefono, setTelefono] = useState('');
    const [formularioValido, setFormularioValido] = useState(true);
    const [showLoading, setLoading] = useState(false);
    const { enqueueSnackbar } = useSnackbar();
    const [rfcValido, setRFCValido] = useState(false);
    const [curpInvalida, setCurpInvalida] = useState(true);
    const personaRazonSocial = enums.tipoPersonaRazonSocial;

    const handleTab = (event: React.ChangeEvent<{}>, newValue: string) => {
        setTabFacturador(newValue);
    };

    const handleChangeTelefono = (event: React.ChangeEvent<HTMLInputElement>) => {
        setTipoTelefono(Number((event.target as HTMLInputElement).value));
    };

    const handleChangePais = (event: React.ChangeEvent<{ value: unknown }>) => {
        setPaisId(Number(event.target.value));
        getCatalogos("/estado/estado-pais/" + event.target.value).then(data => {
            setEstados(data);
        });

        if (codigoPostal) {
            buscarPorCodigoPostal(Number(event.target.value)).then(response => {
                if (response != null && response.length) {
                    setEstados([response[0].estado]);
                    setEstadoId(response[0].estado.id);
                    setCiudades([response[0].ciudad]);
                    setCiudadId(response[0].ciudad.id);
                    let colonias: any[] = [];
                    response.forEach(col => {

                        colonias.push({ id: col.id, nombreColonia: col.nombreColonia, codigoPostal: col.codigoPostal });
                    });
                    setColonias(colonias);
                }
            });
        }
    };

    const handleChangeEstado = (event: React.ChangeEvent<{ value: unknown }>) => {
        setEstadoId(Number(event.target.value));
        getCatalogos("/ciudad/ciudad-estado/" + event.target.value).then(data => {
            setCiudades(data);
        });
    };

    const handleChangeCiudad = (event: React.ChangeEvent<{ value: unknown }>) => {
        setCiudadId(Number(event.target.value));
        getCatalogos("/colonia/colonia-ciudad/" + event.target.value).then(data => {
            setColonias(data);
            setColoniaId(0);
            setColonia([]);
        });
    };

    const handleChangeColonia = (event: any) => {
        setColoniaId(Number(event.id));
        setColonia(event);
        if (tipoPersona != personaRazonSocial.particular && tipoPersona != personaRazonSocial.extranjero) {
            setCodigoPostal(event.codigoPostal);
        }

    };

    const obtenerCodigoPostalEmpresa = async (Id?: number) => {
        const data = { Id: 5 };
        const result = await apiSource.obtenerAsync<any>(`empresa/${Id}/by-id`);
        return result;
    }

    const handleChangeTipoPersona = (event: React.ChangeEvent<{ value: unknown }>) => {
        const value = Number(event.target.value);

        setRFC('');

        if (value === personaRazonSocial.particular || value === personaRazonSocial.extranjero) {
            setRFC(value === personaRazonSocial.particular ? enums.tipoRfc.particular : enums.tipoRfc.extranjero);
            setRFCValido(true);
            setRegimenFiscal(11);
            setUsoCfdi(23);
            obtenerCodigoPostalEmpresa(empresaId).then(response => {
                if (response != null) {
                    setCodigoPostal(response.codigoPostal);
                }
            });

        }

        setTipoPersona(value);
    };

    const handleChangeTipoGiro = (event: React.ChangeEvent<{ value: unknown }>) => {

        setTipoGiro(Number(event.target.value));
    };

    const handleChangeFormaPago = (event: React.ChangeEvent<{ value: unknown }>) => {

        setMetodoPagoId(Number(event.target.value));
    };

    const handleChangeCodigoPostal = (event) => {
        setCodigoPostal(event.target.value);
    };

    const handleChangeResidenciaFiscal = (event) => {
        if (event.target.value === 0)
            setResidenciaFiscal("0");
        else
            setResidenciaFiscal(event.target.value);
    }

    const handleChangeUsoCFDI = (event) => {
        setUsoCfdi(event.target.value);
    }

    const handleChangeRegimenFiscal = async (event) => {
        setRegimenFiscal(event.target.value);

        let result: any = await apiSource.obtenerPorIdAsync("uso-cFDI", event.target.value);
        setUsosCfdi(result);


    }

    const handleBuscaDireccion = (event) => {
        const codigo = event.target.value;
        setCodigoPostal(codigo);
        if (paisId > 0) {
            if (!codigo) {
                getCatalogos("/estado/estado-pais/" + paisId).then(data => {
                    setEstados(data);
                    setEstadoId(0);
                    setCiudades([]);
                    setColonias([]);
                    setCiudadId(0);
                    setColoniaId(0);
                    setColonia([]);
                });
            } else {
                buscarPorCodigoPostal(paisId).then(response => {
                    if (response != null && response.length) {
                        setEstados([response[0].estado]);
                        setEstadoId(response[0].estado.id);
                        setCiudades([response[0].ciudad]);
                        setCiudadId(response[0].ciudad.id);
                        let colonias: any[] = [];
                        response.forEach(col => {

                            colonias.push({
                                id: col.id,
                                nombreColonia: col.nombreColonia,
                                codigoPostal: col.codigoPostal
                            });
                        });
                        setColonias(colonias);

                        if (!colonias.some(e => e.id === coloniaId)) {
                            setColoniaId(0);
                            setColonia([]);
                        }
                    }
                });
            }
        }
    }

    const buscarPorCodigoPostal = async (paisId?: number) => {
        const data = { Texto: codigoPostal, paisId: paisId };
        const result = await apiSource.obtenerAsync<IAutocomplete[]>("colonia/by-text-and-country", data);

        return result;
    }

    const getCatalogos = async (url) => {
        const result = await apiSource.obtenerAsync<any>(url);
        return result;
    };

    const getResidenciasFiscales = async () => {
        const result = await apiSource.obtenerAsync<any>("solicitud-servicio/get-catalogo-residencia-fiscal");
        return result;
    };

    const getParametros = async () => {
        const result = await apiSource.obtenerAsync<any>('parametro/active');
        return result;
    }

    const datosGeneralesValidos = (): boolean => {
        const formatoCurpValido = !curp || validarCurp(curp);
        const regimenValido = !regimenFiscalObligatorio || regimenFiscal !== 0;
        const usoCfdiValido = !usoCfdiObligatorio || usoCfdi !== 0;
        let curpValida = formatoCurpValido && (tipoPersona != personaRazonSocial.fisica || !!curp);

        setCurpInvalida(!curpValida);

        return tipoPersona !== 0
            && razonSocial !== ''
            && nombreComercial !== ''
            && tipoGiro !== 0
            && metodoPagoId !== 0
            && regimenValido
            && usoCfdiValido
            && curpValida
            && rfcValido
    }

    const validaDatosGenerales = () => {
        setFormularioValido(false);

        if (datosGeneralesValidos()) {
            if (!razonSocial.match(/[<>]/) && !nombreComercial.match(/[<>]/)) {
                setFormularioValido(true);
                setTabFacturador("Direcciones");
            }
        }
    }

    const validarDireccion = () => {
        setFormularioValido(false);

        if (!datosGeneralesValidos()) {
            setTabFacturador("DatosGenerales");
            return;
        }

        if (paisId !== 0 && estadoId !== 0 && ciudadId !== 0 && coloniaId !== 0 && calle !== '' && codigoPostal !== '' && noExterior !== '' && telefono !== '') {
            if (!calle.match(/[<>]/) && !noInterior.match(/[<>]/)) {

                setFormularioValido(true);
                setLoading(true);

                guardarCliente().then(response => {
                    setLoading(false);
                    if (response.id === 0) {
                        setTabFacturador("DatosGenerales");
                        enqueueSnackbar(traducirLabel(269), { variant: "error" });
                        return;
                    }

                    let cliente = {
                        id: response.id,
                        clienteNombre: nombreComercial,
                        clienteRFC: rfc.toUpperCase()
                    };

                    guardarClienteResidenciaFiscal({ clienteId: cliente.id, residenciaFiscal: residenciaFiscal })
                        .then(response1 => {

                        });
                    guardarClienteRegimenFiscalUsoCFDI({ clienteId: cliente.id, regimenFiscalId: regimenFiscal, usoCFDIId: usoCfdi })
                        .then(response2 => {

                        });
                    guardarClienteCatalogoUsoCFDI({ clienteId: cliente.id, regimenFiscalId: regimenFiscal, usoCFDIId: usoCfdi })
                        .then(response3 => {
                        });
                    const urlValidarCliente = `/cliente/validar-cliente/${response.id}`;
                    apiSource.postAsync<ICliente>(urlValidarCliente).then();

                    setFacturador(cliente);
                    confirmar();
                }).catch(err => {
                    setLoading(false);
                    swal.fire({
                        titleText: 'Error!',
                        text: traducirMessage(211), // "Ocurrio un error al guardar la Facturador.",
                        type: 'error',
                    });
                })
            }
        }
    };

    let guardarCliente = async () => {
        const result = await apiSource.postAsync<ICliente>("/cliente/guardar-cliente", setFacturadorDto());
        return result;
    }

    let guardarClienteResidenciaFiscal = async (residenciaFiscal) => {
        const result = await apiSource.postAsync<any>("/cliente-configuracion-residencia-fiscal/guarda-cliente-residencia-fiscal", residenciaFiscal);
        return result;
    }

    let guardarClienteRegimenFiscalUsoCFDI = async (regimenFiscal) => {
        const result = await apiSource.postAsync<any>("/cliente-regimen-fiscal-uso-cFDI/guarda-regimen-fiscal-uso-cFDI", regimenFiscal);
        return result;
    }

    let guardarClienteCatalogoUsoCFDI = async (usoCfdi) => {
        const result = await apiSource.postAsync<any>("/cliente-catalogo-uso-cFDI/guarda-regimen-fiscal-uso-cFDI", usoCfdi);
        return result;
    }

    const setFacturadorDto = (): IFacturadorDto => {
        return {
            id: clienteId,
            tipoPersonaId: tipoPersona,
            razonSocial: razonSocial,
            nombreComercial: nombreComercial,
            rfc: rfc,
            curp: curp,
            tipoGiroId: tipoGiro,
            metodoPagoId: metodoPagoId,
            paisId: paisId,
            estadoId: estadoId,
            ciudadId: ciudadId,
            coloniaId: coloniaId,
            colonia: colonia.nombreColonia,
            calle: calle,
            codigoPostal: codigoPostal.toString(),
            noExterior: noExterior.toString(),
            noInterior: noInterior.toString(),
            telefono: telefono.toString(),
            tipoTelefonoId: tipoTelefono,
            nombrePCMod: usuario,
            clienteCredito: { usoCfdiID: usoCfdi }
        };
    };

    const handleRFC = (data: any) => {
        let value = data;
        value = value.replace(/[^a-zA-Z0-9 ]/g, "");
        setRFC(value);
    }

    const validateRFC = (e) => {
        const rfcValido = validarRfc(e.target.value, tipoPersona);
        setRFCValido(rfcValido);
    }

    const errorRfc = (): string => {
        if (formularioValido || rfcValido) {
            return "";
        }

        return !rfc ? traducirLabel(25) : traducirLabel(269);  // "Campo requerido": "RFC no válido";
    }

    const errorCurp = (): string => {
        if (formularioValido || !curpInvalida || !curp && tipoPersona !== personaRazonSocial.fisica) {
            return "";
        }

        return !!curp ? traducirMessage(144) : traducirLabel(25); // "La estructura de la curp es incorrecta, favor de verificar" : "Campo requerido";
    }

    const handleCurp = (data: any) => {
        let value = data;
        value = value.replace(/[^a-zA-Z0-9 ]/g, "");
        setCURP(value);

        if (value) {
            const valorValido = validarCurp(value);
            setCurpInvalida(!valorValido);
        }
    }

    useEffect(() => {
        getCatalogos("/tipo-persona/many").then(data => {
            setTiposPersona(data);
        });
        getCatalogos("/tipo-giro/many").then(data => {
            setGiros(data);
        });
        getCatalogos("/metodo-pago/many").then(data => {
            setMetodosPago(data);
        });
        getCatalogos("/regimen-fiscal/many").then(data => {
            setRegimenesFiscales(data);
        });
        getCatalogos("/pais/many").then(data => {
            setPaises(data);
        });
        getCatalogos("/uso-cFDI/many").then(data => {
            setUsosCfdi(data);
        });
        getResidenciasFiscales().then(data => {
            setResidenciasFiscales(data);

            setResidenciaFiscal("MEX");
        })

        getParametros().then(data => {
            let regimenFiscalEntity = data.find(a => a.nombre === 'Clave Régimen Fiscal Obligatorio');
            let usoCfdiEntity = data.find(a => a.nombre === 'Uso de CFDI Obligatorio');

            if (regimenFiscalEntity !== undefined)
                setRegimenFiscalObligatorio(regimenFiscalEntity.valor === '1');

            if (usoCfdiEntity !== undefined)
                setUsoCfdiObligatorio(usoCfdiEntity.valor === '1');

        })
    }, []);

    return (<>
        <Dialog open={abierto} maxWidth={maxWidth ? maxWidth : "md"} fullWidth={true} onClose={cerrar}>
            <DialogTitle id="simple-dialog-title">
                <Box display="flex" alignItems="center">
                    <Box flexGrow={1} textAlign="center">
                        {/* Datos del Facturador */
                            traducirLabel(73)}
                    </Box>
                    <Box>
                        <IconButton onClick={cerrar}>
                            <CloseIcon />
                        </IconButton>
                    </Box>
                </Box>
            </DialogTitle>
            <DialogContent dividers>
                <DialogContentText>
                    <TabContext value={tabFacturador}>
                        <TabList indicatorColor="primary" textColor="primary"
                            value={tabFacturador} onChange={handleTab}
                            variant="scrollable" scrollButtons="auto">
                            <Tab label={traducirLabel(75)} value="DatosGenerales" />
                            <Tab label={traducirLabel(97)} value="Direcciones" />

                        </TabList>
                        <TabPanel value="DatosGenerales">
                            <Box>
                                <Help comments={traducirMessage(1)} customStyle={{ top: "-40px", right: "-45px" }} />
                            </Box>
                            <Container maxWidth="xl" fixed >
                                <form noValidate autoComplete="off" >

                                    <FormControl required fullWidth variant="outlined" className={classes.padding}>

                                        <InputLabel id="tipoPersona-label" >{traducirLabel(301)}</InputLabel>
                                        <Select onChange={handleChangeTipoPersona} value={tipoPersona}
                                            labelId="tipoPersona-label"
                                            id="tipoPersona"
                                            error={tipoPersona == 0 && !formularioValido}>
                                            <MenuItem key={0} value={0}>
                                                {/* --Seleccione-- */
                                                    `--${traducirMessage(241)}--`}
                                            </MenuItem>
                                            {tiposPersona !== null && localStorage.getItem("idioma") === 'en-US' && tiposPersona.map((option) => (
                                                <MenuItem key={option.id} value={option.id}>
                                                    {option.etiquetaTipoPersona.nombre}
                                                </MenuItem>
                                            ))}
                                            {tiposPersona !== null && localStorage.getItem("idioma") !== 'en-US' && tiposPersona.map((option) => (
                                                <MenuItem key={option.id} value={option.id}>
                                                    {option.nombre}
                                                </MenuItem>
                                            ))}
                                        </Select>
                                        <FormHelperText error >{tipoPersona === 0 && !formularioValido ? `${traducirLabel(25)}` : ''}</FormHelperText>
                                    </FormControl>

                                    <FormControl required fullWidth variant="outlined" className={classes.padding}>
                                        <InputLabel id="residenciaFiscal-label" >{traducirLabel(263)}</InputLabel>
                                        <Select onChange={handleChangeResidenciaFiscal} value={residenciaFiscal}
                                            labelId="residenciaFiscal-label"
                                            id="residenciaFiscal"
                                            error={tipoPersona == 5 && residenciaFiscal == "0" && !formularioValido}>
                                            <MenuItem key={0} value={0}>
                                                {/* --Seleccione-- */
                                                    `--${traducirMessage(241)}--`}
                                            </MenuItem>
                                            {residenciasFiscales != null && residenciasFiscales.map((option) => (
                                                <MenuItem key={option.clave} value={option.clave}>
                                                    {option.descripcion}
                                                </MenuItem>
                                            ))}
                                        </Select>
                                    </FormControl>

                                    <TextField className={classes.padding} fullWidth id="razonSocial" variant="outlined" label={traducirLabel(253)}
                                        required
                                        value={razonSocial}
                                        error={(razonSocial === "" && !formularioValido) ? true : (razonSocial !== "" && razonSocial.match(/[<>]/) ? true : false)}
                                        helperText={(razonSocial === "" && !formularioValido) ? `${traducirLabel(25)}` : (razonSocial !== "" && razonSocial.match(/[<>]/)) ? 'No se permiten los caracteres especiales <> en este campo' : ''}
                                        onChange={e => setRazonSocial(e.target.value)}
                                        inputProps={{ maxLength: 100 }} />

                                    <TextField className={classes.padding} fullWidth label={traducirLabel(203)} id="nombreComercial" variant="outlined" required
                                        onChange={e => setNombreComercial(e.target.value)}
                                        value={nombreComercial}
                                        error={(nombreComercial === "" && !formularioValido) ? true : (nombreComercial !== "" && nombreComercial.match(/[<>]/)) ? true : false}
                                        helperText={(nombreComercial === "" && !formularioValido) ? `${traducirLabel(25)}` : (nombreComercial !== "" && nombreComercial.match(/[<>]/)) ? 'No se permiten los caracteres especiales <> en este campo' : ''}
                                        inputProps={{ maxLength: 100 }} />

                                    <TextField className={classes.padding} fullWidth label={traducirLabel(268)} variant="outlined" required
                                        onChange={e => handleRFC(e.target.value)}
                                        onKeyUp={validateRFC}
                                        value={rfc}
                                        disabled={!tipoPersona || tipoPersona === personaRazonSocial.particular || tipoPersona === personaRazonSocial.extranjero}
                                        error={(rfc === "" || !rfcValido) && !formularioValido}
                                        helperText={errorRfc()}
                                        inputProps={{ maxLength: tipoPersona === personaRazonSocial.moral ? 12 : 13 }} />

                                    <TextField className={classes.padding} fullWidth label={traducirLabel(63)} id="curp" variant="outlined" required={tipoPersona == 1 ? true : false}
                                        onChange={e => handleCurp(e.target.value)}
                                        value={curp}
                                        error={errorCurp() !== ""}
                                        helperText={errorCurp()}
                                        inputProps={{ maxLength: 20, style: { textTransform: 'uppercase' } }} />

                                    <FormControl required fullWidth variant="outlined" className={classes.padding}>
                                        <InputLabel htmlFor="giro">
                                            {/* Giro */
                                                traducirLabel(149)}
                                        </InputLabel>
                                        <Select onChange={handleChangeTipoGiro} id="giro" value={tipoGiro}
                                            error={tipoGiro == 0 && !formularioValido ? true : false}>
                                            <MenuItem key={0} value={0}>
                                                {/* --Seleccione-- */
                                                    traducirMessage(241)}
                                            </MenuItem>
                                            {localStorage.getItem("idioma") === 'en-US' && giros != null && giros.map((option) => (
                                                <MenuItem key={option.id} value={option.id}>
                                                    { option.etiquetaTipoGiro?.nombre == null ? option.nombre : option.etiquetaTipoGiro?.nombre}
                                                </MenuItem>
                                            ))}
                                            {localStorage.getItem("idioma") !== 'en-US' && giros != null && giros.map((option) => (
                                                <MenuItem key={option.id} value={option.id}>
                                                    {option.nombre}
                                                </MenuItem>
                                            ))}
                                        </Select>
                                        <FormHelperText error >{tipoGiro === 0 && !formularioValido ? `${traducirLabel(25)}` : ''}</FormHelperText>

                                    </FormControl>
                                    <FormControl required fullWidth variant="outlined" className={classes.padding}>
                                        <InputLabel htmlFor="formaPago">{traducirLabel(143)}</InputLabel>
                                        <Select onChange={handleChangeFormaPago} id="formaPago" value={metodoPagoId}
                                            error={metodoPagoId == 0 && !formularioValido ? true : false}>
                                            <MenuItem key={0} value={0}>
                                                {/* --Seleccione-- */
                                                    traducirMessage(241)}
                                            </MenuItem>
                                            {localStorage.getItem("idioma") === 'en-US' && metodosPago != null && metodosPago.map((option) => (
                                                <MenuItem key={option.id} value={option.id}>
                                                    { option.etiquetaMetodoPago?.nombre == null ? option.nombre : option.etiquetaMetodoPago?.nombre }
                                                </MenuItem>
                                            ))}
                                            {localStorage.getItem("idioma") !== 'en-US' && metodosPago != null && metodosPago.map((option) => (
                                                <MenuItem key={option.id} value={option.id}>
                                                    {option.nombre}
                                                </MenuItem>
                                            ))}
                                        </Select>
                                        <FormHelperText error >{metodoPagoId === 0 && !formularioValido ? `${traducirLabel(25)}` : ''}</FormHelperText>
                                    </FormControl>
                                    {regimenFiscalObligatorio}
                                    <FormControl required fullWidth variant="outlined" className={classes.padding}>
                                        <InputLabel id="claveRegimenFiscal-label" >{traducirLabel(35)}</InputLabel>
                                        <Select onChange={handleChangeRegimenFiscal} value={regimenFiscal}
                                            labelId="claveRegimenFiscal-label"
                                            id="regimenFiscal"
                                            disabled={!tipoPersona || tipoPersona === personaRazonSocial.particular || tipoPersona === personaRazonSocial.extranjero}
                                            error={regimenFiscal == 0 && !formularioValido && regimenFiscalObligatorio ? true : false}>
                                            <MenuItem key={0} value={0}>
                                                {/* --Seleccione-- */
                                                    traducirMessage(241)}
                                            </MenuItem>
                                            {regimenesFiscales != null && regimenesFiscales.map((option) => (
                                                <MenuItem key={option.id} value={option.id}>
                                                    {option.nombre}
                                                </MenuItem>
                                            ))}
                                        </Select>
                                    </FormControl>

                                    <FormControl required fullWidth variant="outlined" className={classes.padding}>
                                        <InputLabel id="usoCfdi-label" >
                                            {/* Uso CFDI */
                                                traducirLabel(309)}
                                        </InputLabel>
                                        <Select onChange={handleChangeUsoCFDI} value={usoCfdi}
                                            labelId="usoCfdi-label"
                                            id="usoCfdi"
                                            disabled={!tipoPersona || tipoPersona === personaRazonSocial.particular || tipoPersona === personaRazonSocial.extranjero}
                                            error={usoCfdi == 0 && !formularioValido && usoCfdiObligatorio ? true : false}>

                                            <MenuItem key={0} value={0}>
                                                {/* --Seleccione-- */
                                                    traducirMessage(241)}
                                            </MenuItem>
                                            {usosCfdi != null && usosCfdi.map((option) => (
                                                <MenuItem key={option.id} value={option.id}>
                                                    {option.nombre}
                                                </MenuItem>
                                            ))}
                                        </Select>
                                    </FormControl>

                                </form>

                            </Container>
                            <Grid item xs={12} className={classes.actions}>
                                <Button variant="contained" autoFocus onClick={validaDatosGenerales} color="primary">
                                    {/* Continuar */
                                        traducirButton(7)}
                                </Button>
                            </Grid>

                        </TabPanel>
                        <TabPanel value="Direcciones">
                            <Box>
                                <Help comments="AgregarFacturadorDireccionesSolicitud" ayuda={ayuda} customStyle={{ top: "-40px", right: "-45px" }} />
                            </Box>
                            <Container maxWidth="xl" fixed >
                                <form noValidate autoComplete="off">
                                    <Grid container spacing={4}>
                                        <Grid item xs={6}>
                                            <FormControl required fullWidth variant="outlined" className={classes.padding}>
                                                <InputLabel htmlFor="pais" >
                                                    {/* País */
                                                        traducirLabel(224)}
                                                </InputLabel>
                                                <Select onChange={handleChangePais}
                                                    id="pais"
                                                    value={paisId}
                                                    error={paisId == 0 && !formularioValido}>
                                                    <MenuItem key={0} value={0}>
                                                        {/* --Seleccione-- */
                                                            traducirMessage(241)}
                                                    </MenuItem>
                                                    {localStorage.getItem("idioma") === 'en-US' && paises !== null && paises.map((option) => (
                                                        <MenuItem key={option.id} value={option.id}>
                                                            {option.etiquetaPais.nombre}
                                                        </MenuItem>
                                                    ))}
                                                    {localStorage.getItem("idioma") !== 'en-US' && paises !== null && paises.map((option) => (
                                                        <MenuItem key={option.id} value={option.id}>
                                                            {option.nombre}
                                                        </MenuItem>
                                                    ))}
                                                </Select>
                                                <FormHelperText error >{paisId === 0 && !formularioValido ? `${traducirLabel(25)}` : ''}</FormHelperText>
                                            </FormControl>
                                            <FormControl required fullWidth variant="outlined" className={classes.padding}>
                                                <InputLabel htmlFor="ciudad" >
                                                    {/* Ciudad */
                                                        traducirLabel(33)}
                                                </InputLabel>
                                                <Select onChange={handleChangeCiudad}
                                                    id="ciudad" value={ciudadId}
                                                    error={ciudadId == 0 && !formularioValido}>
                                                    <MenuItem key={0} value={0}>
                                                        {/* --Seleccione-- */
                                                            traducirMessage(241)}
                                                    </MenuItem>
                                                    {ciudades != null && ciudades.map((option) => (
                                                        <MenuItem key={option.id} value={option.id}>
                                                            {option.nombre}
                                                        </MenuItem>
                                                    ))}
                                                </Select>
                                                <FormHelperText error >{ciudadId === 0 && !formularioValido ? `${traducirLabel(25)}` : ''}</FormHelperText>
                                            </FormControl>
                                            <TextField className={classes.padding} fullWidth id="calle" variant="outlined" label={traducirLabel(24)} required
                                                value={calle}
                                                error={(calle === "" && !formularioValido) ? true : (calle !== "" && calle.match(/[<>]/) ? true : false)}
                                                helperText={(calle === "" && !formularioValido) ? `${traducirLabel(25)}` : (calle !== "" && calle.match(/[<>]/)) ? 'No se permiten los caracteres especiales <> en este campo' : ''}
                                                onChange={e => setCalle(e.target.value)} inputProps={{ maxLength: 50 }} />

                                            <TextField className={classes.padding} fullWidth id="noExterior" variant="outlined" label={traducirLabel(196)} required
                                                value={noExterior || ''}
                                                error={noExterior === "" && !formularioValido}
                                                InputLabelProps={{ shrink: noExterior ? true : undefined, }}
                                                helperText={noExterior === "" && !formularioValido ? `${traducirLabel(25)}` : ''}
                                                onChange={e => setNoExterior(e.target.value)}
                                                InputProps={{
                                                    inputComponent: ReferenciaNumberField as any,
                                                    inputProps: { precision: 0, maxLength: 10, min: 0 },

                                                }} />

                                            <TextField className={classes.padding} fullWidth id="telefono" variant="outlined" label={traducirLabel(290)} required
                                                value={telefono}
                                                error={telefono === "" && !formularioValido}
                                                helperText={telefono === "" && !formularioValido ? `${traducirLabel(25)}` : ''}
                                                InputLabelProps={{ shrink: telefono ? true : undefined, }}
                                                InputProps={{
                                                    inputComponent: ReferenciaNumberField as any,
                                                    inputProps: { precision: 0, maxLength: 15, min: 0 },
                                                }}
                                                onChange={e => setTelefono(e.target.value)} />
                                        </Grid>
                                        <Grid item xs={6}>
                                            <FormControl required fullWidth variant="outlined" className={classes.padding}>
                                                <InputLabel htmlFor="estado" >
                                                    {/* Estado */
                                                        traducirLabel(123)}
                                                </InputLabel>
                                                <Select onChange={handleChangeEstado}
                                                    id="estado"
                                                    value={estadoId}
                                                    error={estadoId == 0 && !formularioValido}>
                                                    <MenuItem key={0} value={0}>
                                                        {/* --Seleccione-- */
                                                    traducirMessage(241)}
                                                    </MenuItem>

                                                    {estados != null && estados.map((option) => (
                                                        <MenuItem key={option.id} value={option.id}>
                                                            {option.nombre}
                                                        </MenuItem>
                                                    ))}
                                                </Select>
                                                <FormHelperText error >{estadoId === 0 && !formularioValido ? `${traducirLabel(25)}` : ''}</FormHelperText>
                                            </FormControl>
                                            <FormControl required fullWidth variant="outlined" className={classes.padding}>
                                                <Autocomplete
                                                    options={colonias}
                                                    getOptionLabel={(option) => option?.nombreColonia}
                                                    value={colonia}
                                                    onChange={(event, value) => handleChangeColonia(value)}
                                                    renderInput={(params) => <TextField label={traducirLabel(42)} /*"Colonia"*/ {...params} variant="outlined" />}
                                                />

                                                <FormHelperText error >{coloniaId === 0 && !formularioValido ? `${traducirLabel(25)}` : ''}</FormHelperText>
                                            </FormControl>

                                            {<TextField className={classes.padding} fullWidth id="cp" variant="outlined" label={traducirLabel(61)} required
                                                value={codigoPostal}
                                                disabled={!tipoPersona || tipoPersona === personaRazonSocial.particular || tipoPersona === personaRazonSocial.extranjero}
                                                error={codigoPostal === "" && !formularioValido}
                                                helperText={codigoPostal === "" && !formularioValido ? `${traducirLabel(25)}` : ''}
                                                onChange={handleChangeCodigoPostal}
                                                onBlur={handleBuscaDireccion}
                                                InputLabelProps={{ shrink: codigoPostal ? true : undefined, }}
                                                InputProps={{
                                                    inputComponent: ReferenciaNumberField as any,
                                                    inputProps: { precision: 0, maxLength: 6, min: 0 },
                                                }}
                                            />}

                                            <TextField className={classes.padding} fullWidth id="noInterior" variant="outlined" label={traducirLabel(198)}
                                                value={noInterior}
                                                inputProps={{ maxLength: 10 }} onChange={e => setNoInterior(e.target.value)}
                                            />

                                            <FormControl fullWidth variant="outlined" className={classes.padding}>
                                                <RadioGroup aria-label="telefono" value={tipoTelefono} onChange={handleChangeTelefono}>
                                                    <FormControlLabel value={1} control={<Radio />} label={traducirLabel(31)} />
                                                    <FormControlLabel value={2} control={<Radio />} label={traducirLabel(140)} />
                                                </RadioGroup>
                                            </FormControl>
                                        </Grid>
                                    </Grid>
                                </form>
                            </Container>
                            <Grid item xs={12} className={classes.actions}>
                                <Button variant="contained" className={classes.button} onClick={validarDireccion} color="primary" >
                                    {/* Guardar */
                                        traducirButton(14)}
                                </Button>
                            </Grid>
                        </TabPanel>
                    </TabContext>
                </DialogContentText>
            </DialogContent>

        </Dialog>
        {showLoading &&
            <> <LoadingDialog titulo={traducirLabel(240)} abierto={true} /></>
        }
    </>)
};

export default AgregarFacturador;
